// extracted by mini-css-extract-plugin
module.exports = {"percentage-text":"style_percentage-text__3YJX0"};